var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.125C13.6914 11.125 15.0625 9.75387 15.0625 8.0625C15.0625 6.37113 13.6914 5 12 5C10.3086 5 8.9375 6.37113 8.9375 8.0625C8.9375 9.75387 10.3086 11.125 12 11.125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00001 15.9348C4.99884 15.594 5.06827 15.2574 5.20305 14.9505C5.626 14.0218 6.81872 13.5297 7.80843 13.3068C8.5222 13.1396 9.24584 13.0279 9.97394 12.9725C11.322 12.8425 12.6778 12.8425 14.0258 12.9725C14.7539 13.0285 15.4775 13.1402 16.1913 13.3068C17.181 13.5297 18.3738 13.9754 18.7967 14.9505C19.0678 15.5762 19.0678 16.3027 18.7967 16.9284C18.3738 17.9035 17.181 18.3492 16.1913 18.5628C15.4784 18.7369 14.7545 18.8518 14.0258 18.9064C12.9286 19.0085 11.8263 19.0271 10.7268 18.9621C10.473 18.9621 10.2277 18.9621 9.97394 18.9064C9.24799 18.8525 8.52686 18.7376 7.81689 18.5628C6.81872 18.3492 5.63446 17.9035 5.20305 16.9284C5.06895 16.6179 4.9996 16.2784 5.00001 15.9348Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f30ace74b671869b17f02fa3dc6a3040.svg";
export { ForwardRef as ReactComponent };